module.exports = __webpack_public_path__ + "img/gestion.e81f22a0.png";